"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GenericInput_1 = require("../genericInput/GenericInput");
var formattedDate = function (value) {
    var _a;
    return (_a = value) === null || _a === void 0 ? void 0 : _a.replace(/\//g, '-');
};
var DatePickerInput = function (_a) {
    var schemaField = _a.schemaField, toggleDatePicker = _a.toggleDatePicker, errorMessage = _a.errorMessage;
    var _b, _c, _d;
    var _e = schemaField.formData, label = _e.label, required = _e.required, id = _e.id, onChange = _e.onChange, value = _e.value, inputLabel = _e.options.inputLabel, placeholder = _e.placeholder;
    var propsValue = schemaField.props.value;
    react_1.useEffect(function () {
        onChange(formattedDate(propsValue));
    }, [propsValue]);
    var handleChange = react_1.useCallback(function (e) {
        onChange(formattedDate(e.target.value));
    }, [value]);
    return (<GenericInput_1.default label={label} required={required} id={id} value={propsValue} currentError={errorMessage} onChange={handleChange} inputLabel={inputLabel} datePicker toggleDatePicker={toggleDatePicker} placeholder={placeholder} data-test={(_d = (_c = (_b = schemaField) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.inputProps) === null || _d === void 0 ? void 0 : _d['data-test']}/>);
};
exports.default = DatePickerInput;
